<template>
  <div id="SendDetails">
       <DtList :orderId="orderId" @priceList="priceList"></DtList>
  </div>
</template>

<script>
import  DtList from '../common/RemDtList '
export default {
  created() {
     this.orderId= this.$route.query.orderId
  },
  data() {
    return {
      orderId:'',
      DTList: []
    };
  },
  methods: {
    priceList(DTList){
      this.DTList = DTList
    }
  },
  components:{
    DtList
  }
};
</script>

<style>

</style>